// Import Swiper components and styles
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { faArrowRight , faArrowLeft } from '@fortawesome/free-solid-svg-icons';
// Import required modules
import { Navigation, Pagination } from 'swiper/modules';

// Import CSS and Images
import './Slider.css';
import slide1 from '../images/P17.webp';
import slide2 from '../images/P19.webp';
import slide3 from '../images/P25.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Slider = () => {
  const slides = [
    {
      id: 1,
      image: slide1,
      title: 'Installation und Wartung von Solaranlagen im Saarland und Rheinland-Pfalz',
      description:
        'Nutzen Sie die Kraft der Sonne mit unseren Photovoltaik-Komplettlösungen – von der Planung über die Installation bis zur Wartung. Wir bieten effiziente Systeme mit Power-Inverter und Batteriespeichern, um Ihre Energienutzung zu maximieren. Zusätzlich kümmern wir uns um die Pflege, Reinigung und Fehlerdiagnose der Solarmodule, unterstützt durch Drohnentechnologie, für optimale Leistung und Langlebigkeit.',
      buttonText: 'Mehr lesen',
      link: 'leistungen/photovoltaik',
    },
    {
      id: 2,
      image: slide2,
      title: 'Haus Installation – Wir beraten Sie gern ',
      description:
        'Sie planen ein neues Zuhause? Wir bieten umfassende Unterstützung bei der Elektroinstallation – von der ersten Planung bis zur Abnahme. Unser Team sorgt für eine sichere, zukunftssichere und effiziente Umsetzung, die perfekt auf Ihre Bedürfnisse zugeschnitten ist. Vertrauen Sie auf unsere Expertise für eine reibungslose Installation, damit Ihr Bauprojekt stressfrei gelingt.',
      buttonText: 'Mehr lesen',
      link: 'leistungen/installation',
    },
    {
      id: 3,
      image: slide3,
      title: 'Intelligente Ladestation / Wallbox – Ihre E-Mobilität, Ihre Zukunft',
      description:
        'Laden Sie Ihr E-Fahrzeug bequem zu Hause oder im Unternehmen auf – schnell, sicher und effizient. Unsere modernen Wallbox-Systeme bieten optimalen Schutz und sind zukunftssicher, perfekt für Privat- und Firmenkunden. Dank intelligenter Technologie integrieren sie sich nahtlos in Ihr Energiemanagement und bereiten Sie auf die Mobilität von morgen vor.',
      buttonText: 'Mehr lesen',
      link: 'leistungen/ladestation',
    },
  ];

  return (
    <section>
      <div className="slider-container">
        <Swiper
          modules={[Navigation, Pagination]}
          effect="slide"
          speed={1300}
          navigation={{
            prevEl: '#slide-prev',
            nextEl: '#slide-next',
          }}
          pagination={{
            el: '.swiper-pagination',
            clickable: true,
            bulletElement: 'div',
          }}
          className="slider-wrapper"
        >
          {slides.map((slide) => (
            <SwiperSlide
              key={slide.id}
              className="slider-item"
              style={{
                backgroundImage: `url(${slide.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div className="slide-content">
                <h1 className="slide-title">
                    {slide.id === 1 ? (
                        <>
                            {slide.title.split('Solaranlagen')[0]}
                            <span>Solaranlagen</span>
                            {slide.title.split('Solaranlagen')[1]}
                            
                        </>
                    ) : (
                        slide.title
                    )}
                </h1>
                <p className="slide-description">{slide.description}</p>
                <a href={slide.link} className="slide-button">
                  {slide.buttonText}
                </a>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="swiper-pagination"></div>
        <div className="slider-navigations">
          <button id="slide-prev">
             <FontAwesomeIcon className="button-arrows" icon={faArrowLeft}></FontAwesomeIcon>
          </button>
          <button id="slide-next">
          <FontAwesomeIcon className="button-arrows" icon={faArrowRight}></FontAwesomeIcon>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Slider;